export default __webpack_public_path__ + "static/media/login_screen_group_1.051caedd.png";